import { render, staticRenderFns } from "./ChiAmi_body.vue?vue&type=template&id=689a0944"
import script from "./ChiAmi_body.vue?vue&type=script&lang=js"
export * from "./ChiAmi_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports